import { useState, useEffect } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getExternalSupport } from '../api';

export const useExternalSupport = () => {
  const [tickets, setTickets] = useState([]);

  const {
    data,
    error,
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery(
    ['tickets'],
    async ({ pageParam = 1 }) => {
      const res = await getExternalSupport({
        page: pageParam,
      });
      return res;
    },
    {
      getNextPageParam: (lastPage, pages) => pages.length + 1,
    },
  );

  useEffect(() => {
    if (data) {
      console.log(data);
      const arr: any = data?.pages.map((item: any) => ({ ...item?.data?.data?.tickets }));
      console.log(Object.values(arr));
      setTickets(Object.values(arr));
    }
  }, [data]);

  return {
    tickets,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  };
};
